/* Crowd Designs 2.0 theme scripts */
(function () {
  'use strict';
  var mb = document.getElementById('menu-btn');
  var nav = document.getElementById('nav');
  if (mb && nav) {
    mb.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      mb.setAttribute('aria-expanded', String(open));
    });
    nav.addEventListener('click', function (e) {
      if (e.target && e.target.tagName === 'A') {
        nav.classList.remove('open');
        mb.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // Product gallery thumbnails
  var main = document.getElementById('pdp-main');
  var thumbs = document.querySelectorAll('[data-thumb]');
  Array.prototype.forEach.call(thumbs, function (b) {
    b.addEventListener('click', function () {
      if (!main) return;
      main.src = b.getAttribute('data-full');
      main.alt = b.getAttribute('data-alt') || '';
      Array.prototype.forEach.call(thumbs, function (x) {
        x.setAttribute('aria-current', x === b ? 'true' : 'false');
      });
    });
  });

  // Variant price
  var sel = document.getElementById('variant-select');
  var price = document.getElementById('pdp-price');
  if (sel && price) {
    sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex];
      price.innerHTML = '';
      var b = document.createElement('b');
      b.textContent = o.getAttribute('data-price') || '';
      price.appendChild(b);
      var c = o.getAttribute('data-compare');
      if (c) {
        var s = document.createElement('s');
        s.textContent = c;
        price.appendChild(s);
      }
    });
  }

  // Collection sorting
  var sort = document.getElementById('sort-by');
  if (sort) {
    sort.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  }

  // Client slides
  var cars = document.querySelectorAll('[data-carousel]');
  Array.prototype.forEach.call(cars, function (car) {
    var sec = car.closest('section');
    var prev = sec.querySelector('[data-car-prev]');
    var next = sec.querySelector('[data-car-next]');
    var dots = sec.querySelector('[data-dots]');
    var n = car.children.length;
    var go = function (i) {
      car.scrollTo({ left: i * car.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    if (prev) prev.addEventListener('click', function () { car.scrollBy({ left: -car.clientWidth, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { car.scrollBy({ left: car.clientWidth, behavior: 'smooth' }); });
    if (dots && n > 1) {
      for (var i = 0; i < n; i++) {
        (function (idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
          b.setAttribute('aria-current', idx === 0 ? 'true' : 'false');
          b.addEventListener('click', function () { go(idx); });
          dots.appendChild(b);
        })(i);
      }
      car.addEventListener('scroll', function () {
        var idx = Math.round(car.scrollLeft / car.clientWidth);
        Array.prototype.forEach.call(dots.children, function (b, j) { b.setAttribute('aria-current', String(idx === j)); });
      }, { passive: true });
    }
  });
})();

/* ===================== Apple-style behaviour ===================== */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('js');
  var site = d.querySelector('.site'), img = d.querySelector('.hero img'), dock = d.getElementById('dock');
  var seen = { design: false, bulk: false }, tick = false;

  function frame() {
    tick = false;
    var y = window.pageYOffset || 0;
    if (site) site.classList.toggle('scrolled', y > 8);
    if (img && !reduced && y < 1000) {
      img.style.transform = 'translate3d(0,' + (y * 0.14).toFixed(1) + 'px,0) scale(' + (1 + y * 0.00016).toFixed(4) + ')';
      img.style.opacity = String(Math.max(0.4, 1 - y / 1500));
    }
    var h3 = d.getElementById('hero3d');
    var limit = h3 ? h3.offsetHeight * 0.92 : window.innerHeight * 0.7;
    if (dock) dock.classList.toggle('show', y > limit && !seen.design && !seen.bulk);
  }
  function onScroll() { if (!tick) { tick = true; window.requestAnimationFrame(frame); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  frame();

  if ('IntersectionObserver' in window) {
    ['design', 'bulk'].forEach(function (id) {
      var el = d.getElementById(id);
      if (!el) return;
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { seen[id] = e.isIntersecting; frame(); });
      }, { threshold: 0.12 }).observe(el);
    });
  }

  var SEL = '.sec-h,.strip .wrap>*,.tile,.pc,.uc,.ct,.slide,.mapbox,.pillar>div,.form,.steps li,.mades,.crowd .wrap>*,.about .wrap>div>*';
  var io = ('IntersectionObserver' in window && !reduced) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      el.classList.add('in');
      io.unobserve(el);
      var wait = 1300 + (parseInt(el.style.getPropertyValue('--d'), 10) || 0);
      setTimeout(function () { el.classList.remove('rv', 'in'); el.style.removeProperty('--d'); }, wait);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }) : null;

  window.CDReveal = function (scope) {
    if (!io) return;
    Array.prototype.forEach.call((scope || d).querySelectorAll(SEL), function (el) {
      if (el.getAttribute('data-rv')) return;
      el.setAttribute('data-rv', '1');
      var idx = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.setProperty('--d', (Math.min(idx, 8) * 70) + 'ms');
      el.classList.add('rv');
      io.observe(el);
    });
  };
  window.CDReveal();
})();
